import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import {
    ApiResponse,
    handleAxiosError
} from "./responses/AxiosResponseHandler";
import { PromoterGroupOpenClubsApiResponse } from "./responses/PromoterGroupOpenClubsApiResponse";
import BookingType from "./enums/BookingType";

interface QueryParameters {
    City: string,
    PartyDate: Date,
    BookingType: BookingType,
    PromoterId: string
};

class OpenClubsForPromoterGroupApi {
    private authClient: AuthClient;
    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }

    public mapBookingType(bookingTypeString: string): BookingType {
        switch (bookingTypeString.toLowerCase()) {
            case 'guestlist':
                return BookingType.GuestList;
            case 'tablebooking':
                return BookingType.TableBooking;
            case 'privateparty':
                return BookingType.PrivateParty;
            case 'notset':
                return BookingType.NotSet;
            case 'joinviptable':
                return BookingType.JoinVIPTable;
            default:
                return BookingType.NotSet;
        }
    }

    public async getPromoterGroupOpenClubs(city: string, partyDate: Date, bookingType: string, promoterId: string): Promise<ApiResponse<PromoterGroupOpenClubsApiResponse> | undefined> {
        try {
            const authenticationResponse = this.authClient.getAuthenticationResponse();
            if (authenticationResponse == null) {
                return undefined;
            }

            if (city == "" && partyDate) {
                console.error("Promoter's ID and Group ID not find!");
                return {
                    data: {
                        openClubs: []
                    },
                    statusCode: 404,
                    errorMessage: "Promoter's ID and Group ID not recieved!",
                };
            }

            const bookingTypeResponse = this.mapBookingType(bookingType);

            const queryParams: QueryParameters = {
                City: city,
                PartyDate: partyDate,
                BookingType: bookingTypeResponse,
                PromoterId: promoterId
            };

            const response = await axios.get(
                `${this.authClient.getApiRoot()}/Clubs/PromoterOpenClubs`,
                {
                    params: queryParams,
                    headers: {
                        Authorization: `Bearer ${authenticationResponse.token}`,
                    },
                }
            );

            return {
                statusCode: response.status,
                errorMessage: "",
                data: {
                    openClubs: response.data
                }
            };
        } catch (error) {
            const errorResponse = handleAxiosError<PromoterGroupOpenClubsApiResponse>(
                error as AxiosError
            );
            return {
                statusCode: errorResponse.statusCode,
                errorMessage: errorResponse.errorMessage,
                data: errorResponse.data,
            };
        }
    }
}

export default OpenClubsForPromoterGroupApi;